import { ref, Ref } from "@vue/composition-api";
import UserSettingsInterface from "@/interfaces/userSettings.interface";

const formUserSettings: Ref<Record<string, { value: string; id?: number }>> = ref({
    enforceTeamFilter: {
        value: "0",
    },
    enforceUnassignedChats: {
        value: "0",
    },
});

export default function useUsersForm() {
    const setUserSettings = (settings: UserSettingsInterface[]): void => {
        settings.forEach((setting) => {
            if (formUserSettings.value[setting.name]) {
                formUserSettings.value[setting.name].value = setting.value;
                formUserSettings.value[setting.name].id = setting.id;
            }
        });
    };

    const getUserSettingsAsArray = (): UserSettingsInterface[] => {
        return Object.entries(formUserSettings.value).map(([name, setting]) => ({
            name,
            value: setting.value,
            id: setting.id,
        }));
    };

    return {
        formUserSettings,
        setUserSettings,
        getUserSettingsAsArray,
    };
}
